var map = {
	"./cn.svg": "XFoh",
	"./de.svg": "MNhF",
	"./es.svg": "Ch2N",
	"./fr.svg": "DWSb",
	"./gb.svg": "fFSG",
	"./it.svg": "0X9p",
	"./jp.svg": "9Tvm",
	"./ro.svg": "gPXr",
	"./us.svg": "fypI"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZisU";